import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, computed, inject, input } from '@angular/core';

import { SitecorePopularBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { PopularBetsPodEventLogoDetails } from '../popular-bets.models';

@Component({
    selector: 'ms-popular-bets-pod-event-logo',
    templateUrl: './popular-bets-pod-event-logo.component.html',
    styleUrl: './popular-bets-pod-event-logo.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ParticipantImageComponent, IconCustomComponent, NgOptimizedImage],
})
export class PopularBetsPodEventLogoComponent {
    logoDetails = input.required<PopularBetsPodEventLogoDetails>();
    sportId = input.required<number>();
    showLogoColor = input<boolean>(true);
    messages = inject(SitecorePopularBetsConfig).messages;

    private readonly className = computed(() => {
        switch (this.logoDetails().logoType) {
            case 'OpenBullets':
                return 'popular-bets-option__bullet-icon';
            case 'RadioOff':
                return 'popular-bets-option__radio-off';
            default:
                return 'popular-bets-option__event-logo';
        }
    });

    @HostBinding('class')
    get hostClassName(): string {
        return this.className();
    }

    get bulletIconName(): string {
        return this.messages.BulletIconName || 'theme-open-bullet';
    }

    get bulletIconSize(): number {
        return +this.messages.BulletIconSize || 10;
    }
}
